const React = require('react');
const withState = require('../../../../../utils/withState');
const noop = require("mn-utils/noop");
const inputCtor = require("../../utils/inputCtor");
const ErrorDisplay = require("../ErrorDisplay");
const LabelDisplay = require("../LabelDisplay");

const InputsDisplay = withState((setState, self) => {
  const arrayOfFields = new Array(self.props.codeLength || 1).fill('');
  return (state, props) => {
    const {
      name,
      value = '',
      onChange = noop,
      codeLength,
      error,
      testId
    } = props;

    const arrayOfValues = value.split('');

    return (
      <div className="layoutRow mt10 mh-10 (ph10)>1">
        {arrayOfFields.map((el, i) => (
          <div key={i}>
            <input
              className={
                `code-field dB olc0 w40 h40 bgF b1 bs bc8 (bc0|olc0):f bcF00.error r9 tc ff$3`
                + (error ? ' error' : '')
              }
              value={arrayOfValues[i] || ''}
              onFocus={() => {
                const codeFieldsArr = document.getElementsByClassName('code-field');
                const prevField = codeFieldsArr[i - 1];
                if (prevField && !prevField.value) prevField.focus();
              }}
              onKeyDown={(e) => {
                const key = e.key;

                if (key !== 'Backspace') return;

                let nextFieldIndex = i;

                if (arrayOfValues[i]) {
                  arrayOfValues[i] = '';
                } else {
                  arrayOfValues[i - 1] = '';
                  nextFieldIndex = i - 1;
                }

                onChange(name, arrayOfValues.join(''));

                setTimeout(() => {
                  const codeFieldsArr = document.getElementsByClassName('code-field');
                  const nextField = codeFieldsArr[nextFieldIndex];

                  if (nextField) nextField.focus();
                });
              }}
              onChange={(e) => {
                let nextValue = e.target.value || '';

                if (isNaN(nextValue)) return;

                if (nextValue.length >= codeLength) {
                  nextValue = nextValue.slice(0, codeLength);
                  nextValue.split('').forEach((key, i) => arrayOfValues[i] = key);
                } else {
                  arrayOfValues[i] = nextValue.slice(-1);
                  nextValue = arrayOfValues.join('');
                }

                onChange(name, nextValue);

                setTimeout(() => {
                  const codeFieldsArr = document.getElementsByClassName('code-field');
                  const nextField = codeFieldsArr[codeLength - 1];

                  if (nextField) nextField.focus();
                })
              }}
              data-testid={`${testId}-${i}`}
            />
          </div>
        ))}
      </div>
    );
  }
})

const Component = ({
  labelProps= {},
  inputProps = {},
  errorProps = {},
  codeLength
}) => {
  return (
    <div className="rlv pb15">
      <LabelDisplay {...labelProps} />
      <InputsDisplay {...inputProps} codeLength={codeLength} />
      <ErrorDisplay {...errorProps} />
    </div>
  );
};

module.exports = inputCtor(Component)
